!function (win, defineBase) {
if (typeof define === "function" && (define.amd || define.cmd)) {define(function () {return defineBase(win);});}
else if (typeof exports === "object" && typeof module === "object") {module.exports = defineBase(win);}
else {defineBase(win, !0);}
}(this, function (globle, noMD) {var win = globle || {};var MIDAS = {};
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Impression"] = factory();
	else
		root["Impression"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2016-11-05 09:37
 * @author vivaxy
 */

var MUTATION = exports.MUTATION = 'mutation';
var RESIZE = exports.RESIZE = 'resize';
var SCROLL = exports.SCROLL = 'scroll';
var UNLOAD = exports.UNLOAD = 'unload';

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2016-11-05 10:13
 * @author vivaxy
 */

var BEGIN = exports.BEGIN = 'begin';
var END = exports.END = 'end';

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @since 2016-10-30 14:35
 * @author vivaxy
 */

var STATIC = 'static';
var RELATIVE = 'relative';

exports.default = function (container) {
    // for calculating offset
    if (container instanceof HTMLElement) {
        var style = window.getComputedStyle(container);

        if (style.position === STATIC) {
            container.style.position = RELATIVE;
        }
    }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty,
    prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = [],
      events,
      name;

  if (this._eventsCount === 0) return names;

  for (name in events = this._events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event,
      available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt],
      len = arguments.length,
      args,
      i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1:
        return listeners.fn.call(listeners.context), true;
      case 2:
        return listeners.fn.call(listeners.context, a1), true;
      case 3:
        return listeners.fn.call(listeners.context, a1, a2), true;
      case 4:
        return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6:
        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len - 1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length,
        j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1:
          listeners[i].fn.call(listeners[i].context);break;
        case 2:
          listeners[i].fn.call(listeners[i].context, a1);break;
        case 3:
          listeners[i].fn.call(listeners[i].context, a1, a2);break;
        case 4:
          listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
        default:
          if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this),
      evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true),
      evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * @since 2016-10-30 14:47
 * @author vivaxy
 */

exports.default = function (callback, timeout) {
    var timer = void 0;

    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        clearTimeout(timer);

        timer = setTimeout(function () {
            callback.apply(undefined, args);
        }, timeout);
    };
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _events = __webpack_require__(1);

var eventTypes = _interopRequireWildcard(_events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var diffBySelector = function diffBySelector(selector, tracked, isViewable, type) {
    var previousNodes = tracked.nodes;

    tracked.nodes = [];

    var currentNodes = document.querySelectorAll(selector);

    Array.prototype.forEach.call(currentNodes, function (currentNode) {
        var wasVisible = false;
        if (previousNodes) {
            previousNodes.forEach(function (previousItem) {
                var previousNode = previousItem.node;
                if (!previousItem.marked && previousNode === currentNode) {
                    wasVisible = previousItem.isVisible;
                    previousItem.marked = true;
                }
            });
        }

        var item = {
            isVisible: isViewable(currentNode),
            wasVisible: wasVisible,
            node: currentNode
        };

        tracked.nodes.push(item);

        if (item.isVisible === true && item.wasVisible === false) {
            tracked.events.emit(eventTypes.BEGIN, currentNode, {
                type: type
            });
        }
        if (item.isVisible === false && item.wasVisible === true) {
            tracked.events.emit(eventTypes.END, currentNode, {
                type: type
            });
        }
    });

    if (previousNodes) {
        // for removed nodes
        previousNodes.forEach(function (previousItem) {
            if (!previousItem.marked) {
                if (previousItem.isVisible) {
                    tracked.events.emit(eventTypes.END, previousItem.node, {
                        type: type
                    });
                }
            }
        });
    }
}; /**
    * @since 2016-11-05 10:01
    * @author vivaxy
    */

exports.default = function (trackedElements, type, isViewable) {
    var selectors = Object.keys(trackedElements);
    selectors.forEach(function (selector) {
        var tracked = trackedElements[selector];
        diffBySelector(selector, tracked, isViewable, type);
    });
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _events = __webpack_require__(1);

var eventTypes = _interopRequireWildcard(_events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var endBySelector = function endBySelector(selector, tracked, type) {
    var previousNodes = tracked.nodes;
    if (previousNodes) {
        previousNodes.forEach(function (previousItem) {
            var previousNode = previousItem.node;
            if (previousNode.isVisible) {
                tracked.events.emit(eventTypes.END, previousItem.node, {
                    type: type
                });
            }
        });
    }
}; /**
    * @since 2016-11-05 10:06
    * @author vivaxy
    */

exports.default = function (trackedElements, type) {
    var selectors = Object.keys(trackedElements);
    selectors.forEach(function (selector) {
        var tracked = trackedElements[selector];
        endBySelector(selector, tracked);
    });
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * @since 2016-11-05 11:11
 * @author vivaxy
 */

exports.default = function (value, object) {
    return Object.keys(object).some(function (constant) {
        return object[constant] === value;
    });
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mutation = __webpack_require__(11);

var _mutation2 = _interopRequireDefault(_mutation);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

var _scroll = __webpack_require__(13);

var _scroll2 = _interopRequireDefault(_scroll);

var _unload = __webpack_require__(14);

var _unload2 = _interopRequireDefault(_unload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2016-10-30 15:12
 * @author vivaxy
 */

exports.default = function (container) {
    var mutationListener = (0, _mutation2.default)(document.body);
    var resizeListener = (0, _resize2.default)(container);
    var scrollListener = (0, _scroll2.default)(container);
    var unloadListener = (0, _unload2.default)();

    var on = function on(callback) {
        mutationListener.on(callback);
        resizeListener.on(callback);
        scrollListener.on(callback);
        unloadListener.on(callback);
        return true;
    };

    var off = function off() {
        mutationListener.off();
        resizeListener.off();
        scrollListener.off();
        unloadListener.off();
        return true;
    };

    return {
        on: on,
        off: off
    };
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _attributes = __webpack_require__(15);

var _attributes2 = _interopRequireDefault(_attributes);

var _styles = __webpack_require__(18);

var _styles2 = _interopRequireDefault(_styles);

var _inContainer = __webpack_require__(16);

var _inContainer2 = _interopRequireDefault(_inContainer);

var _onScreen = __webpack_require__(17);

var _onScreen2 = _interopRequireDefault(_onScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * check if an element is viewable
 * @param element {Node}
 * @param container {Node}
 * @param tolerance {Number}
 * @returns {boolean}
 */
/**
 * @since 2016-10-30 14:52
 * @author vivaxy
 */

exports.default = function (element, container, tolerance) {
    var visible = true;
    var currentNode = element;

    if (container === window) {
        visible = (0, _onScreen2.default)(element, tolerance);
    } else {
        visible = (0, _inContainer2.default)(element, container, tolerance);
    }

    while (currentNode.parentNode && visible) {
        visible = (0, _attributes2.default)(currentNode) && (0, _styles2.default)(currentNode);
        currentNode = currentNode.parentNode;
    }
    return visible;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @since 2016-10-28 12:21
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author vivaxy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _eventemitter = __webpack_require__(3);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _validators = __webpack_require__(9);

var _validators2 = _interopRequireDefault(_validators);

var _observers = __webpack_require__(8);

var _observers2 = _interopRequireDefault(_observers);

var _debounce = __webpack_require__(4);

var _debounce2 = _interopRequireDefault(_debounce);

var _diffTrackedElements = __webpack_require__(5);

var _diffTrackedElements2 = _interopRequireDefault(_diffTrackedElements);

var _endTrackedElements = __webpack_require__(6);

var _endTrackedElements2 = _interopRequireDefault(_endTrackedElements);

var _isValueIn = __webpack_require__(7);

var _isValueIn2 = _interopRequireDefault(_isValueIn);

var _observers3 = __webpack_require__(0);

var observerTypes = _interopRequireWildcard(_observers3);

var _events = __webpack_require__(1);

var eventTypes = _interopRequireWildcard(_events);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = exports.default = function () {
    function Impression() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$tolerance = _ref.tolerance,
            tolerance = _ref$tolerance === undefined ? 0 : _ref$tolerance,
            _ref$debounce = _ref.debounce,
            debounce = _ref$debounce === undefined ? 100 : _ref$debounce,
            _ref$container = _ref.container,
            container = _ref$container === undefined ? window : _ref$container;

        _classCallCheck(this, Impression);

        this._attached = false;
        this._trackedElements = {};
        this._tolerance = tolerance;
        this._debounce = debounce;
        this._container = container;
        this._observers = (0, _observers2.default)(this._container);
        this._handler = (0, _debounce2.default)(this._handlers.bind(this), this._debounce);
        this._events = new _eventemitter2.default();

        this.attach();
    }

    _createClass(Impression, [{
        key: 'attach',
        value: function attach() {
            if (!this._attached) {
                this._attached = true;
                this._observers.on(this._handler);
            }
            return this;
        }
    }, {
        key: 'detach',
        value: function detach() {
            if (this._attached) {
                this._observers.off();
                this._attached = false;
            }
            return this;
        }
    }, {
        key: 'isViewable',
        value: function isViewable(element) {
            return (0, _validators2.default)(element, this._container, this._tolerance);
        }
    }, {
        key: 'on',
        value: function on(event, selector, callback) {
            if ((0, _isValueIn2.default)(event, eventTypes)) {
                this._onViewableChange(event, selector, callback);
            } else {
                throw new Error('impression: event not accepted: ' + event);
            }
            return this;
        }
    }, {
        key: 'once',
        value: function once(event, selector, callback) {
            if ((0, _isValueIn2.default)(event, eventTypes)) {
                this._onceViewableChange(event, selector, callback);
            } else {
                throw new Error('impression: event not accepted: ' + event);
            }
            return this;
        }
    }, {
        key: 'off',
        value: function off(event, selector, callback) {
            this._offViewableChange(event, selector, callback);
            return this;
        }
    }, {
        key: 'onObservers',
        value: function onObservers(event, callback) {
            if ((0, _isValueIn2.default)(event, observerTypes)) {
                this._events.on(event, callback);
            } else {
                throw new Error('impression: event not accepted: ' + event);
            }
            return this;
        }
    }, {
        key: 'onceObservers',
        value: function onceObservers(event, callback) {
            if ((0, _isValueIn2.default)(event, observerTypes)) {
                this._events.once(event, callback);
            } else {
                throw new Error('impression: event not accepted: ' + event);
            }
            return this;
        }
    }, {
        key: 'offObservers',
        value: function offObservers(event, callback) {
            if (event) {
                if (callback) {
                    this._events.removeListener(event, callback);
                } else {
                    this._events.removeAllListeners(event);
                }
            } else {
                this._events.removeAllListeners();
            }
            return this;
        }
    }, {
        key: '_handlers',
        value: function _handlers(type) {

            this._events.emit(type);

            var trackedElements = this._trackedElements;
            if (type === observerTypes.UNLOAD) {
                (0, _endTrackedElements2.default)(trackedElements, type);
            } else {
                (0, _diffTrackedElements2.default)(trackedElements, type, this.isViewable.bind(this));
            }
            return this;
        }
    }, {
        key: '_onViewableChange',
        value: function _onViewableChange(event, selector, callback) {
            if (!this._trackedElements[selector]) {
                this._trackedElements[selector] = {};
            }
            var tracked = this._trackedElements[selector];
            if (!tracked.nodes) {
                tracked.nodes = [];
            }
            if (!tracked.events) {
                tracked.events = new _eventemitter2.default();
            }
            tracked.events.on(event, callback);
            return this;
        }
    }, {
        key: '_onceViewableChange',
        value: function _onceViewableChange(event, selector, callback) {
            if (!this._trackedElements[selector]) {
                this._trackedElements[selector] = {};
            }
            var tracked = this._trackedElements[selector];
            if (!tracked.nodes) {
                tracked.nodes = [];
            }
            if (!tracked.events) {
                tracked.events = new _eventemitter2.default();
            }
            tracked.events.once(event, callback);
            return this;
        }
    }, {
        key: '_offViewableChange',
        value: function _offViewableChange(event, selector, callback) {
            if (event) {
                if (selector) {
                    this._offViewableChangeBySelector(event, selector, callback);
                } else {
                    this._offViewableChangeByEvent(event);
                }
                this._cleanUpTracked();
            } else {
                this._offViewableChangeAll();
            }
            return this;
        }
    }, {
        key: '_offViewableChangeBySelector',
        value: function _offViewableChangeBySelector(event, selector, callback) {
            var trackedElements = this._trackedElements;
            if (callback) {
                // event, selector, callback: remove single callback for this selector, this event
                var tracked = trackedElements[selector];
                if (tracked && tracked.events) {
                    tracked.events.removeListener(event, callback);
                }
            } else {
                // event, selector: remove all callbacks for this selector, this event
                var _tracked = trackedElements[selector];
                if (_tracked && _tracked.events) {
                    _tracked.events.removeAllListeners(event);
                }
            }
            return this;
        }
    }, {
        key: '_offViewableChangeByEvent',
        value: function _offViewableChangeByEvent(event) {
            var trackedElements = this._trackedElements;
            // event: remove all callbacks for all selectors, this event
            Object.keys(trackedElements).forEach(function (selector) {
                var tracked = trackedElements[selector];
                if (tracked && tracked.events) {
                    tracked.events.removeAllListeners(event);
                }
            });
            return this;
        }
    }, {
        key: '_offViewableChangeAll',
        value: function _offViewableChangeAll() {
            var trackedElements = this._trackedElements;
            // : remove all callbacks for all selectors, all events
            Object.keys(trackedElements).forEach(function (selector) {
                // Reflect.deleteProperty(trackedElements, selector);
                delete trackedElements[selector];
            });
            return this;
        }
    }, {
        key: '_cleanUpTracked',
        value: function _cleanUpTracked() {
            var trackedElements = this._trackedElements;
            // clean up useless tracked
            Object.keys(trackedElements).forEach(function (selector) {
                var tracked = trackedElements[selector];
                if (tracked && tracked.events) {
                    if (tracked.events.listeners(eventTypes.BEGIN).length === 0 && tracked.events.listeners(eventTypes.END).length === 0) {
                        // Reflect.deleteProperty(trackedElements, selector);
                        delete trackedElements[selector];
                    }
                }
            });
            return this;
        }
    }]);

    return Impression;
}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _presets = __webpack_require__(2);

var _presets2 = _interopRequireDefault(_presets);

var _observers = __webpack_require__(0);

var observers = _interopRequireWildcard(_observers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2016-10-30 14:24
 * @author vivaxy
 */

var DOM_NODE_INSERTED = 'DOMNodeInserted';
var DOM_NODE_REMOVED = 'DOMNodeRemoved';
var DOM_ATTR_MODIFIED = 'DOMAttrModified';
var DOM_SUBTREE_MODIFIED = 'DOMSubtreeModified';

exports.default = function (container) {
    var attached = void 0;
    var mutationObserver = void 0;
    var _callback = void 0;

    var on = function on(callback) {
        if (attached) {
            return false;
        } else {
            attached = true;
            _callback = function _callback() {
                return callback(observers.MUTATION);
            };
            (0, _presets2.default)(container);
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            if (MutationObserver) {
                mutationObserver = new MutationObserver(_callback);
                mutationObserver.observe(container, {
                    childList: true,
                    attributes: true,
                    subtree: true
                });
            } else {
                container.addEventListener(DOM_NODE_INSERTED, _callback);
                container.addEventListener(DOM_NODE_REMOVED, _callback);
                container.addEventListener(DOM_ATTR_MODIFIED, _callback);
                container.addEventListener(DOM_SUBTREE_MODIFIED, _callback);
            }
            return true;
        }
    };

    var off = function off() {
        if (attached) {
            if (mutationObserver) {
                mutationObserver.disconnect();
            } else {
                container.removeEventListener(DOM_NODE_INSERTED, _callback);
                container.removeEventListener(DOM_NODE_REMOVED, _callback);
                container.removeEventListener(DOM_ATTR_MODIFIED, _callback);
                container.removeEventListener(DOM_SUBTREE_MODIFIED, _callback);
            }
            attached = false;
            return true;
        } else {
            return false;
        }
    };

    return {
        on: on,
        off: off
    };
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _presets = __webpack_require__(2);

var _presets2 = _interopRequireDefault(_presets);

var _observers = __webpack_require__(0);

var observers = _interopRequireWildcard(_observers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2016-10-30 14:24
 * @author vivaxy
 */

var RESIZE = 'resize';

exports.default = function (container) {
    var attached = false;
    var _callback = void 0;

    var on = function on(callback) {
        if (attached) {
            return false;
        } else {
            attached = true;
            _callback = function _callback() {
                return callback(observers.RESIZE);
            };
            (0, _presets2.default)(container);
            container.addEventListener(RESIZE, _callback);
            return true;
        }
    };

    var off = function off() {
        if (attached) {
            container.removeEventListener(RESIZE, _callback);
            attached = false;
            return true;
        } else {
            return false;
        }
    };

    return {
        on: on,
        off: off
    };
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _presets = __webpack_require__(2);

var _presets2 = _interopRequireDefault(_presets);

var _observers = __webpack_require__(0);

var observers = _interopRequireWildcard(_observers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @since 2016-10-30 14:17
 * @author vivaxy
 */

var SCROLL = 'scroll';

exports.default = function (container) {
    var attached = false;
    var _callback = void 0;

    var on = function on(callback) {
        if (attached) {
            return false;
        } else {
            attached = true;
            _callback = function _callback() {
                return callback(observers.SCROLL);
            };
            (0, _presets2.default)(container);
            container.addEventListener(SCROLL, _callback);

            return true;
        }
    };

    var off = function off() {
        if (attached) {
            container.removeEventListener(SCROLL, _callback);
            attached = false;
            return true;
        } else {
            return false;
        }
    };

    return {
        on: on,
        off: off
    };
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _observers = __webpack_require__(0);

var observers = _interopRequireWildcard(_observers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var BEFORE_UNLOAD = 'beforeunload'; /**
                                     * @since 2016-11-05 09:32
                                     * @author vivaxy
                                     */

exports.default = function () {
    var attached = false;
    var _callback = void 0;

    var on = function on(callback) {
        if (attached) {
            return false;
        } else {
            attached = true;
            _callback = function _callback() {
                return callback(observers.UNLOAD);
            };
            window.addEventListener(BEFORE_UNLOAD, _callback);
            return true;
        }
    };

    var off = function off() {
        if (attached) {
            window.removeEventListener(BEFORE_UNLOAD, _callback);
            attached = false;
            return true;
        } else {
            return false;
        }
    };

    return {
        on: on,
        off: off
    };
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @since 2016-10-30 14:49
 * @author vivaxy
 */

var attributesToCheck = {
    hidden: true
};

exports.default = function (element) {
    return !Object.keys(attributesToCheck).some(function (attr) {
        return element[attr] === attributesToCheck[attr];
    });
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * @since 2016-10-30 14:59
 * @author vivaxy
 */

exports.default = function (element) {
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


    var containerRect = container.getBoundingClientRect();

    var top = element.offsetTop + tolerance < containerRect.height + container.scrollTop;
    var bottom = element.offsetTop + element.clientHeight - tolerance > container.scrollTop;
    var left = element.offsetLeft + tolerance < containerRect.width + container.scrollLeft;
    var right = element.offsetLeft + element.clientWidth - tolerance > container.scrollLeft;

    return top && bottom && left && right;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * @since 2016-10-30 14:55
 * @author vivaxy
 */

exports.default = function (element, tolerance) {

    var rect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;

    var elementHeight = element.offsetHeight;
    var elementWidth = element.offsetWidth;

    var onScreenHeight = tolerance > elementHeight ? elementHeight : tolerance;
    var onScreenWidth = tolerance > elementWidth ? elementWidth : tolerance;

    // top
    var elementBottomToWindowTop = rect.top + elementHeight;
    var bottomBoundingOnScreen = elementBottomToWindowTop >= onScreenHeight;

    // bottom
    var elementTopToWindowBottom = windowHeight - (rect.bottom - elementHeight);
    var topBoundingOnScreen = elementTopToWindowBottom >= onScreenHeight;

    // left
    var elementRightToWindowLeft = rect.left + elementWidth;
    var rightBoundingOnScreen = elementRightToWindowLeft >= onScreenWidth;

    // right
    var elementLeftToWindowRight = windowWidth - (rect.right - elementWidth);
    var leftBoundingOnScreen = elementLeftToWindowRight >= onScreenWidth;

    return bottomBoundingOnScreen && topBoundingOnScreen && rightBoundingOnScreen && leftBoundingOnScreen;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @since 2016-10-30 14:53
 * @author vivaxy
 */

var stylesToCheck = {
    display: 'none',
    visibility: 'hidden'
};

exports.default = function (element) {
    var style = window.getComputedStyle(element);
    return !Object.keys(stylesToCheck).some(function (attr) {
        return style[attr] === stylesToCheck[attr];
    });
};

/***/ })
/******/ ]);
});
/**
 * Created by fanjingjian on 17/3/28.
 */

var util = {
    extend: function (receiver, supplier) {
        for (var key in supplier) {
            if (Object.prototype.hasOwnProperty.call(supplier, key)) {
                receiver[key] = supplier[key];
            }
        }
        return receiver;
    },

    /**
     * 绑定事件兼容性处理
     * @param name 监听的事件名称
     * @param callback 事件触发时的回调
     * @param useCapture 是否在捕获阶段执行
     * @param target 绑定时间的目标元素(默认为window)
     */
    addEventListener: function (name, callback, useCapture, target) {
        if (target && target.addEventListener) { //非ie 和ie9
            target.addEventListener(name, callback, false);

        }
        else if (target && target.attachEvent) { //ie6到ie8
            target.attachEvent("on" + name, callback);

        }
        else if (target) { //ie5
            target["on" + name] = callback;
        }
        else if (window.addEventListener) {
            return window.addEventListener(name, callback, useCapture);
        }
        else if (window.attachEvent) {
            return window.attachEvent('on' + name, callback);
        }
    },

    //注册DOMReady事件的函数
    DOMReady: function () {
        var isIE=navigator.userAgent.match(/MSIE (\d)/i);
        isIE=isIE?isIE[1]:undefined;
        //先保存参数列表和参数长度
        var s = arguments, i = s.length;
        if (isIE < 9)//传统浏览器使用doScroll
        //创建计时器
            var itv = setInterval(function () {
                try {//测试doScroll的运行是否错误，如果错误则DOM还没加载完成
                    document.documentElement.doScroll();
                    //如果没有错误，则清除计时器
                    clearInterval(itv);
                    //并且把传入的参数全都调用一遍
                    while (i--)s[i]();
                } catch (e) {
                }
            }, 1);
        else//现代浏览器使用DOMContentLoaded事件
            document.addEventListener("DOMContentLoaded", function () {
                //触发时把传入的函数全都调用一遍
                while (i--)s[i]();
            });
    },

    getParentsAttr: function (ele, attr) {
        var data;
        var eleParent = ele.parentNode;

        while (eleParent.nodeName !== 'BODY' && !eleParent.getAttribute(attr)) {
            eleParent = eleParent.parentNode;
        }
        data = eleParent.getAttribute(attr);

        return data;
    },

    /**
     * page unload
     * onbeforeunload is the right event to fire, but not all browsers don't support it.
     * This allows us to fall back to onunload when onbeforeunload isn't implemented
     */
    onunload: function (callback) {
        this.addEventListener('unload', callback, false);
        this.addEventListener('beforeunload', callback, false);
    },

    now: function () {
        return +(new Date());
    },

    //todo: zhengquexing
    ajax: function ajax(options) {
        //编码数据
        function setData() {
            //设置对象的遍码
            function setObjData(data, parentName) {
                function encodeData(name, value, parentName) {
                    var items = [];
                    name = parentName === undefined ? name : parentName + "[" + name + "]";
                    if (typeof value === "object" && value !== null) {
                        items = items.concat(setObjData(value, name));
                    } else {
                        name = encodeURIComponent(name);
                        value = encodeURIComponent(value);
                        items.push(name + "=" + value);
                    }
                    return items;
                }

                var arr = [], value;
                if (Object.prototype.toString.call(data) == '[object Array]') {
                    for (var i = 0, len = data.length; i < len; i++) {
                        value = data[i];
                        arr = arr.concat(encodeData(typeof value == "object" ? i : "", value, parentName));
                    }
                } else if (Object.prototype.toString.call(data) == '[object Object]') {
                    for (var key in data) {
                        value = data[key];
                        arr = arr.concat(encodeData(key, value, parentName));
                    }
                }
                return arr;
            };
            //设置字符串的遍码，字符串的格式为：a=1&b=2;
            function setStrData(data) {
                var arr = data.split("&");
                var name, value = '';
                for (var i = 0, len = arr.length; i < len; i++) {
                    name = encodeURIComponent(arr[i].split("=")[0]);
                    value = encodeURIComponent(arr[i].split("=")[1]);
                    arr[i] = name + "=" + value;
                }
                return arr;
            }

            if (data) {
                if (typeof data === "string") {
                    data = setStrData(data);
                } else if (typeof data === "object") {
                    data = setObjData(data);
                }
                data = data.join("&").replace("/%20/g", "+");
                //若是使用get方法或JSONP，则手动添加到URL中
                if (type === "get" || dataType === "jsonp") {
                    url += url.indexOf("?") > -1 ? (url.indexOf("=") > -1 ? "&" + data : data) : "?" + data;
                }
            }
        }

        // JSONP
        function createJsonp() {
            var script = document.createElement("script"),
                timeName = new Date().getTime() + Math.round(Math.random() * 1000),
                callback = "JSONP_" + timeName;

            window[callback] = function (data) {
                clearTimeout(timeout_flag);
                document.body.removeChild(script);
                success(data);
            }
            script.src = url + (url.indexOf("?") > -1 ? "&" : "?") + "callback=" + callback;
            script.type = "text/javascript";
            document.body.appendChild(script);
            setTime(callback, script);
        }

        //设置请求超时
        function setTime(callback, script) {
            if (timeOut !== undefined) {
                timeout_flag = setTimeout(function () {
                    if (dataType === "jsonp") {
                        delete window[callback];
                        document.body.removeChild(script);

                    } else {
                        timeout_bool = true;
                        xhr && xhr.abort();
                    }
                    console.log("timeout");

                }, timeOut);
            }
        }

        // XHR
        function createXHR() {
            //由于IE6的XMLHttpRequest对象是通过MSXML库中的一个ActiveX对象实现的。
            //所以创建XHR对象，需要在这里做兼容处理。
            function getXHR() {
                if (window.XMLHttpRequest) {
                    return new XMLHttpRequest();
                } else {
                    //遍历IE中不同版本的ActiveX对象
                    var versions = ["Microsoft", "msxm3", "msxml2", "msxml1"];
                    for (var i = 0; i < versions.length; i++) {
                        try {
                            var version = versions[i] + ".XMLHTTP";
                            return new ActiveXObject(version);
                        } catch (e) {
                        }
                    }
                }
            }

            //创建对象。
            xhr = getXHR();
            xhr.open(type, url, async);
            //设置请求头
            if (type === "post" && !contentType) {
                //若是post提交，则设置content-Type 为application/x-www-four-urlencoded
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
            } else if (contentType) {
                xhr.setRequestHeader("Content-Type", contentType);
            }
            //添加监听
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (timeOut !== undefined) {
                        //由于执行abort()方法后，有可能触发onreadystatechange事件，
                        //所以设置一个timeout_bool标识，来忽略中止触发的事件。
                        if (timeout_bool) {
                            return;
                        }
                        clearTimeout(timeout_flag);
                    }
                    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                        success(xhr.responseText);
                    } else {
                        error(xhr.status, xhr.statusText);
                    }
                }
            };
            //发送请求
            xhr.send(type === "get" ? null : data);
            setTime(); //请求超时
        }

        var url = options.url || "", //请求的链接
            type = (options.type || "get").toLowerCase(), //请求的方法,默认为get
            data = options.data || null, //请求的数据
            contentType = options.contentType || "", //请求头
            dataType = options.dataType || "", //请求的类型
            async = options.async === undefined ? true : options.async, //是否异步，默认为true.
            timeOut = options.timeOut, //超时时间。
            before = options.before || function () {
                }, //发送之前执行的函数
            error = options.error || function () {
                }, //错误执行的函数
            success = options.success || function () {
                }; //请求成功的回调函数
        var timeout_bool = false, //是否请求超时
            timeout_flag = null, //超时标识
            xhr = null; //xhr对角
        setData();
        before();
        if (dataType === "jsonp") {
            createJsonp();
        } else {
            createXHR();
        }
    },

    removeElement: function (_element) {
        var _parentElement = _element.parentNode;
        if (_parentElement) {
            _parentElement.removeChild(_element);
        }
    },

    type: function (_element) {
        if (_element == null) {
            return _element + "";
        }
        return typeof _element;
    },

    isArrayLike: function (_element) {
        var length = !!_element && "length" in _element && _element.length;
        var type = this.type(_element);

        if (type === "function" || _element == window._element) {
            return false;
        }

        return type === "array" || length === 0 ||
            typeof length === "number" && length > 0 && ( length - 1 ) in _element;
    },

    isArray: function (arg) {
        if (!Array.isArray) {
            Array.isArray = function (arg) {
                return Object.prototype.toString.call(arg) === '[object Array]';
            };
        }
        else {
            return Array.isArray(arg);
        }
    },

    /**
     * 判断输入是否为html的dom
     */
    isDOM: ( typeof HTMLElement === 'object' ) ?
        function (obj) {
            return obj instanceof HTMLElement;
        } :
        function (obj) {
            return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
        },

    /**
     * 将search转为对象
     * @param str
     * @returns {{}}
     */
    urlParams: function urlQuery2Obj(str) {
        if (!str) {
            str = location.search;
        }
        if (str[0] === '?' || str[0] === '#') {
            str = str.substring(1);
        }
        var query = {};
        str.replace(/\b([^&=]*)=([^&=]*)/g, function (m, a, d) {
            if (typeof query[a] != 'undefined') {
                query[a] += ',' + decodeURIComponent(d);
            } else {
                query[a] = decodeURIComponent(d);
            }
        });
        return query;
    },

    stopBubble: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.event.cancelBubble = true;
        }
    },

    isNull: function isNull(arg) {
        return !arg && arg !== 0 && typeof arg !== "boolean" ? true : false;
    },

    getAds: function (arg) {
        var ads;
        if (typeof arg === 'string') {
            ads = document.querySelectorAll(arg);
        }
        else {
            ads = arg && arg.element || document.querySelectorAll('[data-midas]');
        }
        ads = this.isArrayLike(ads) ? ads : [].concat(ads);

        return ads;
    },

    eventBus: {
        _eventList: {},
        trigger: function () {
            var _shift = Array.prototype.shift;
            var type = _shift.call(arguments);
            var arg = _shift.call(arguments);

            if (!this._eventList[type]) {
                return false;
            }
            for (var i = 0; i < this._eventList[type].length; i++) {
                this._eventList[type][i].call(this, arg);
            }
        },
        on: function (type, callback) {
            if (typeof callback !== 'function') {
                return;
            }
            if (!this._eventList[type]) {
                this._eventList[type] = [];
            }
            this._eventList[type].push(callback);
        }
    }
};

MIDAS.util = util;

/**
 * Created by fanjingjian on 17/3/28.
 */

var parameter = {
    MAX_URL_LENGTH: 2083,
    actTypeList: [1, 2, 3, 4, 5], // 支持的点的类型 依次为加载点 点击点 曝光点 落地点 第三方点
    PV_ACT: 5, // 第三方点
    CLICK_ACT: 2, // 点击点
    defaultTarget: (function () {
        var protocol = window.location.protocol;
        var host = window.location.host;

        if (host.indexOf('51ping.com') > -1 || host.indexOf('act-test') > -1) {
            return protocol + '//mlog.51ping.com/log';
        }
        else if ((host.indexOf('dianping.com') > -1 && !/^ppe/.test(host)) || (host.indexOf('meituan.com') > -1 && !/test/.test(host))) {
            return protocol + '//mlog.dianping.com/log';
        }

        else {
            // return protocol + '//mlog.51ping.com/log';
            return location.origin;
        }
    })(), // 默认发往的服务器地址

    rate: 20, // 默认延迟20毫秒发送
    immediately: false,
    pvRate: true, // 默认第三方点也延迟发送
    merge: true, // 默认合并点 get 请求合并发送

    autoSendView: true, // 发送加载点
    autoSendReach: true, // 默认自动检测url中的_fb_ 发送落地点
    autoSendClick: false, // 默认自动检测url中的_fb_ 发送落地点
    sendClickInReach: false, // 当前页面跳转时是否不发送点击点 若为true 点击点在落地页发送
    // 若设置 sendClickInReach = true 拼接linkurl后页面立即跳转 建议 immediately属性设置为true

    stopClickPropagation: false, // 阻止点击事件的冒泡
    tolerance: 1, // 默认设定漏出 1px 即打曝光点
    debounce: 100, // 默认设定广告出现并停止滚动后 100 毫秒 打曝光点
    autoRetry: false, // 默认不进行失败重发 //TODO: 改成重试几次 传int
    usePost: false, // 是否强制使用ajax请求
    ajaxAsync: true, // 若使用了 ajax 发送 将异步过程改为同步 默认是异步的
    clickTimeout: 2500, // 若使用了 ajax 发送点加点 即在 data-inner-jump 模式下 点击点超时时间
};

MIDAS.parameter = parameter;

/**
 * Created by fanjingjian on 17/3/28.
 */

var config = function (obj) {
    if(typeof obj === 'undefined'){
        return ;
    }
    else if (typeof obj !== 'object') {
        throw new Error('config方法参数错误');
    }
    else {
        util.extend(parameter, obj);
        // 处理rate: 若rate >= 0 continue；若rate < 0 代表立即执行
        if (obj.rate < 0 || parseInt(obj.rate, 10) < 0) {
            delete parameter.rate;
            parameter.immediately = true;
        }
    }
};

MIDAS.config = config;

/**
 * Created by fanjingjian on 17/3/28.
 */

/**
 * 使用图片的 src 属性发送请求
 * @param url
 */
var getSend = function (url, autoRetry, callback) {
    var image = new Image(1, 1);
    var done = function () {
        if (typeof callback === 'function') {
            callback();
        }
        try {
            image.onload = image.onerror = image.onabort = null;
        } catch (e) {
        }
        image = null;
    };
    // 若设置了需要失败重发
    if (autoRetry) {
        image.onload = image.onerror = done;
        // 失败重发 依靠后端去重
        image.onabort = function () {
            getSend(url, false, callback);
            try {
                image.onload = image.onerror = image.onabort = null;
            } catch (e) {
            }
            image = null;
        };
    }
    else {
        image.onload = image.onerror = image.onabort = done;
    }
    image.src = url;
};

/**
 * ajax 发送 post 请求
 * @param url
 * @param feedback
 */
var postSend = function (url, feedback, ajaxAsync, autoRetry, callback) {
    util.ajax({
        url: url,
        type: 'POST',
        async: ajaxAsync,
        success: function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        },
        error: function (status, statusText) {
            if (autoRetry) {
                postSend(url, feedback, ajaxAsync, false, callback);
                return null;
            }
            else if (typeof callback === 'function') {
                callback(status, statusText);
            }
        },
        data: feedback
    });
};

/**
 * send 方法是发送点的基本方法
 * @param {object | string} arg
 */
var send = function (arg) {
    if (typeof arg === 'undefined') {
        throw new Error('send方法参数错误');
    }

    // 拼装 url
    if (typeof arg === 'string') {
        arg = { url: arg };
    }

    var thisConfig = {
        url: parameter.defaultTarget,
        autoRetry: parameter.autoRetry,
        usePost: parameter.usePost,
        ajaxAsync: parameter.ajaxAsync,
    };

    util.extend(thisConfig, arg);

    var feedback = thisConfig.feedback;
    var callback = thisConfig.callback;
    var url = thisConfig.url;
    var autoRetry = thisConfig.autoRetry;
    var usePost = thisConfig.usePost;
    var ajaxAsync = thisConfig.ajaxAsync;

    var data;

    if (typeof feedback === 'string' && feedback.length > 0) {
        // 认为 feedback 一定含有 & 符号 以此为依据拼装 getUrl
        feedback = feedback.indexOf('&') === -1 ? decodeURIComponent(feedback) : feedback;

        if (!usePost) {
            url = url + (url.indexOf('?') === -1 ? '?' : '&') + feedback;
        }
    }
    else if (util.isArray(feedback)) {
        usePost = true;
    }

    if (url.length >= parameter.MAX_URL_LENGTH) {
        usePost = true;
        feedback = [].concat(url.split('?')[1]);
        url = url.split('?')[0];
    }

    if (usePost) {
        var fb = [].concat(feedback);
        try {
            data = {
                "data": JSON.stringify(fb)
            };
        } catch (e) {
            throw new Error('send方法的POST请求，feedback参数错误');
        }
        // 默认异步发送
        ajaxAsync = typeof ajaxAsync === "boolean" ? ajaxAsync : true;
        try{
            postSend(url, data, ajaxAsync, autoRetry, callback);
        }
        catch (e){
            console.error(e);
        }
    }
    else {
        getSend(url, autoRetry, callback);
    }
};

MIDAS.send = send;

/**
 * Created by fanjingjian on 17/3/28.
 */

var PV_ACT = parameter.PV_ACT;

/**
 * 工厂方法 点进入队列 即Go方法的实例进入队列
 * 根据参数 选择发post点 还是get点 get点需要拼接feedback字段
 * @param {string} target 发往的地址
 * @param {string} feedback 请求参数
 * @param {boolean} usePost 是否使用POST方法
 * @param {boolean} ajaxAsync 是否使用同步异步请求
 * @param {function} callback 请求结束的回调
 * @returns {*} 对send方法的包装
 * @constructor
 */
var Go = function (target, feedback, usePost, ajaxAsync, callback) {
    /**
     * 包装实际的发送方法
     * @param countTask {Function} 点击事件发生时清空任务队列，若为本页跳转模式，需要确保之前所有点都发送出去，触发自定义事件进行计数
     */
    return function (countTask) {
        var cb;
        // 参数为 function 说明处于 广告被点击 且当前页面跳转 在页面跳转前确保完成打点
        if (typeof countTask === 'function') {
            cb = function () {
                // 队列的点的个数减一
                var numberOfTask = countTask();
                // 通过自定义事件将剩余点的个数发送给监听该事件的 initClick 方法内部，该监听器将在 numberOfTask = 0 时执行页面跳转
                util.eventBus.trigger('SEND_BEFORE_LEAVE', numberOfTask);
                // 其他用户自定义回调
                if (typeof callback === 'function') {
                    callback();
                }
            };
        }
        else {
            cb = callback;
        }

        send({
            url: target,
            feedback: feedback,
            usePost: usePost,
            callback: cb,
            ajaxAsync: ajaxAsync,
        });
    };
};

var launcher = (function () {
    // 发射器当前状态标识
    var status = 'empty';
    // 打点任务队列
    var taskQueue = [];
    // 记录setTimeout 的 id
    var taskDelayQueue = [];
    // 标识第一个打点 避免和zipReauest方法的等待时间重叠
    var firstLog = true;
    // 点击点触发时 若是 当前页面跳转模式 记录待发送点的个数
    var countBeforeLeave = 0;
    var handleCount = function () {
        return --countBeforeLeave;
    };

    // 组装feedback
    var buildFeedback = function (item, act) {
        if (item.indexOf('&') === -1) {
            item = decodeURIComponent(item);
        }
        if (/act=(\d)/.exec(item)) {
            return item;
        }
        else {
            return item + '&act=' + act + '&referer=' + encodeURIComponent(document.referrer) + '&t=' + util.now();
        }
    };

    // 根据是否传参数，区别是递归调用 还是单个打点任务
    return function itself(arg, fromZip) {
        var timer = (firstLog || fromZip) ? 0 : parameter.rate;
        firstLog = false;
        var tempTaskName;

        // 有参数 认为是新打点任务
        if (arguments.length > 0) {
            arg = (arg && typeof arg === 'object') ? arg : {};
            var act = arg.act;
            var url = arg.url;
            var feedback = arg.feedback;
            var usePost = arg.usePost;
            var ajaxAsync = arg.ajaxAsync;
            var callback = arg.callback;
            var immediately = typeof arg.immediately === 'boolean' ? arg.immediately : parameter.immediately;

            // 定义打点地址
            var target = url ? url : parameter.defaultTarget;

            if (!Array.isArray(feedback) && act !== PV_ACT) {
                feedback = buildFeedback(feedback, act);
            }
            // 组装参数 非第三方点 才进行处理
            else if (Array.isArray(feedback) && act !== PV_ACT) {
                for (var i = 0, l = feedback.length, tempFeedback = []; i < l; i++) {
                    tempFeedback.push(buildFeedback(feedback[i], act));
                }
                feedback = tempFeedback;
            }
            // 实例化打点请求
            var go = new Go(target, feedback, usePost, ajaxAsync, callback);
            taskQueue.push(go);

            // 点击事件发生 或需要立即发送全部 未发送的点
            if (immediately === true || Number(act) === parameter.CLICK_ACT) {
                for (i = 0, l = taskDelayQueue.length; i < l; i++) {
                    clearTimeout(taskDelayQueue[i]);
                }
                for (i = 0, l = taskQueue.length, countBeforeLeave = l; i < l; i++) {
                    // 点击点发生时，为了确保本页面跳转的情况下尽量不丢点 传入待发送点个数 跳转前监测发送的情况
                    taskQueue[i](handleCount);
                }
                taskDelayQueue = [];
                taskQueue = [];
                status = 'empty';
            }
            // 当前有点待发送
            else if (status === 'notEmpty') {
                return null;
            }
            // timer时间后发送本次任务
            else {
                status = 'notEmpty';
                tempTaskName = setTimeout(function () {
                    try {
                        taskQueue.shift()();
                    }
                    catch (e) {
                        console.error(e);
                    }
                    // 队列中没有待发送的点了
                    if (taskQueue.length === 0) {
                        status = 'empty';
                        return null;
                    }
                    else {
                        return itself();
                    }
                }, timer);
                taskDelayQueue.push(tempTaskName);
            }
        }
        // 来自递归的调用 timer时间后发送队列中的下一个点
        else {
            tempTaskName = setTimeout(function () {
                try {
                    taskQueue.shift()();
                }
                catch (e) {
                    console.error(e);
                }
                if (taskQueue.length === 0) {
                    status = 'empty';
                    return null;
                }
                else {
                    return itself();
                }
            }, timer);
            taskDelayQueue.push(tempTaskName);
        }
    };
})();

MIDAS.launcher = launcher;

/**
 * Created by fanjingjian on 17/3/28.
 */

var zip = (function () {

    var tempParams = {}; // 待合并的点的集合
    var thisTask = {}; // setTimeout 任务的 ID

    return function (arg) {

        var timer = parameter.rate;
        // 无参数的情况下
        if(typeof arg === 'undefined'){
            for(var type in tempParams){
                var t = tempParams[type];
                if(typeof t === 'undefined' || util.isNull(t)) {
                    continue;
                }
                // 仍有未发送的点 清除计时器 同类型的点一次性发送
                thisTask[type] && clearTimeout(thisTask[type]);
                launcher.call(null, t, true);
                delete tempParams[type];
            }
        }
        else{
            // arg 是midas addTask 方法的第二个参数
            if(typeof arg !== 'object' || util.isNull(arg)){
                throw new Error('midas 参数错误');
            }
            var act = arg.act;
            var feedback = arg.feedback;

            // 待合并的点的集合 以act的值为键
            tempParams[act] = tempParams[act] || {};

            // 若timer时间内有新的task 清除定时器
            thisTask[act] && clearTimeout(thisTask[act]);

            // 待合并点的集合中 feedback转为数组
            if(util.isArray(tempParams[act].feedback)){
                tempParams[act].feedback = tempParams[act].feedback.concat(feedback)
            }
            else{
                tempParams[act] = arg;
                tempParams[act].feedback = [].concat(feedback)
            }

            //timer时间后 发送同种类型的点的集合
            thisTask[act] = setTimeout(function(){
                launcher.call(null, tempParams[act], true);
                tempParams[act] = null;
            }, timer);
        }
    }
})();

MIDAS.zip = zip;

/**
 * Created by fanjingjian on 17/3/28.
 */

/**
 * 增加打点任务的方法，参可包含以下字段
 *  act（点的类型）
 *  feedback（打点参数）
 *  url（打点地址）
 *  usePost（改点是否使用post形式发送)
 *  merge（是否把该点合并进下一个post请求）
 *  immediately（是否将当前所有尚未发送的点 立刻全部发送）
 *  autoRetry（发送失败后是否自动重发）
 * @param arg 对象类型
 */
var addTask = function (arg) {

    if (typeof arg !== 'object' || util.isNull(arg)) {
        throw new Error('addTask方法参数错误');
    }

    var act = arg.act;
    var url = arg.url;
    var defaultTarget = parameter.defaultTarget;
    var feedback = arg.feedback;
    var thisMerge = arg.merge;
    var immediately = typeof arg.immediately === 'boolean' ? arg.immediately : parameter.immediately;
    var autoRetry = arg.autoRetry;
    // 因为涉及到zip方法合并打点请求 不能对单个点设置重发机制
    if (!!autoRetry) {
        config({
            autoRetry: true
        });
    }

    // 注册时是否指明要求合并 > config方法中知否指明
    var willMerge = !!(thisMerge === true || typeof thisMerge === 'undefined' && parameter.merge === true);
    // 非发往默认服务器的点 不合并
    if (typeof url === 'string' && url.length > 0 && url.indexOf(defaultTarget) === -1) {
        willMerge = false;
    }
    if (typeof act === 'undefined') {
        act = /act=(\d)/.exec(decodeURIComponent(feedback));
        act = util.isArray(act) ? act.length > 1 ? act[1] : act[0] : act;
        act = typeof act === "number" ? act : parseInt(act, 10);
    }

    if (parameter.actTypeList.indexOf(act) === -1) {
        throw new Error('关键参数act未找到');
    }

    // 设置了禁止合并 点击点
    if (!willMerge || act == 2 || immediately) {
        if (act == 2 || immediately) {
            // 不传参数代表 立刻将已经传入压缩方法的点发送出去
            zip();
        }
        launcher.call(null, arg);
    }
    // 第三方
    else if (act === 5) {
        launcher.call(null, arg);
    }
    else {
        zip.call(null, arg);
    }

};

MIDAS.addTask = addTask;

/**
 * Created by fanjingjian on 17/3/29.
 */

var initView = function (arg) {

    arg = arg || {};

    var PV_ACT = parameter.PV_ACT;
    var ads = util.getAds(arg);

    var thisConfig = {
        merge: parameter.merge,
        pvRate: parameter.pvRate,
        usePost: parameter.usePost,
        ajaxAsync: parameter.ajaxAsync,
        immediately: parameter.immediately,
    };
    util.extend(thisConfig, arg);

    for (var i = 0, j = ads.length; i < j; i++) {

        var ad = ads[i];
        if (typeof ad === 'undefined' || util.isNull(ad)) {
            continue;
        }
        if (!(ad instanceof HTMLElement)) {
            console.error("传入initView方法的element参数有误");
            continue;
        }
        // 避免url等被上一个循环的值覆盖
        var url = thisConfig.url;
        var merge = thisConfig.merge;
        var pvRate = thisConfig.pvRate;
        var usePost = thisConfig.usePost;
        var ajaxAsync = thisConfig.ajaxAsync;
        var immediately = thisConfig.immediately;
        var callback = thisConfig.callback;

        var feedback = ad.getAttribute('data-midas') || '';
        var pvUrl = ad.getAttribute('data-pvurl'); // 第三方加载点
        var viewed = ad.getAttribute('data-viewed');

        if (!viewed) {
            // 包含 ？认为是完整的url 若未指定明确的 url ，按照feedback中的地址直接发送
            if (feedback.indexOf('?') > -1 && typeof url === 'undefined') {
                url = feedback.split('?')[0];
                feedback = feedback.split('?')[1];
            }

            addTask({
                url: url,
                feedback: feedback,
                act: 1,
                immediately: immediately,
                merge: merge,
                usePost: usePost,
                ajaxAsync: ajaxAsync,
                callback: callback,
            });

            // 第三方打点
            if (pvUrl && !pvRate) {
                send(pvUrl);
            }
            else if (pvUrl) {
                addTask({
                    url: pvUrl,
                    act: PV_ACT,
                    merge: false, // 第三方点不合并
                });
            }

            ad.setAttribute('data-viewed', 'true');
        }
    }
};

MIDAS.initView = initView;

/**
 * Created by fanjingjian on 17/3/29.
 */


if(typeof exports === "object" && typeof module === "object"){
    var Impression = require('impression.js');
} else {
    var Impression = win.Impression;
}

/**
 * 发送点的操作
 * @param ele
 * @returns {boolean}
 */
var addNewTask = function (ele, thisConfig) {
    var url = thisConfig.url;
    var merge = thisConfig.merge;
    var pvRate = thisConfig.pvRate;
    var usePost = thisConfig.usePost;
    var ajaxAsync = thisConfig.ajaxAsync;
    var immediately = thisConfig.immediately;
    var callback = thisConfig.callback;

    var PV_ACT = parameter.PV_ACT;

    if (ele.getAttribute('data-midas-impressed')) {
        return false;
    }
    var feedback = ele.getAttribute('data-midas') || '';
    var impressionUrl = ele.getAttribute('data-impressionurl'); // 第三方曝光点

    // 包含 ？认为是完整的url 若未指定明确的 url ，按照feedback中的地址直接发送
    if (feedback.indexOf('?') > -1 && typeof url === 'undefined') {
        url = feedback.split('?')[0];
        feedback = feedback.split('?')[1];
    }
    addTask({
        url: url,
        feedback: feedback,
        act: 3,
        merge: merge,
        usePost: usePost,
        ajaxAsync: ajaxAsync,
        immediately: immediately,
        callback: callback,
    });
    // 第三方渲染打点
    if (impressionUrl && !pvRate) {
        send(impressionUrl);
    }
    else if (impressionUrl) {
        addTask({
            url: impressionUrl,
            act: PV_ACT,
            merge: false,
        });
    }
    ele.setAttribute('data-midas-impressed', true);
};

var initImpression = function (arg) {

    arg = arg || {};
    var thisConfig = {
        tolerance: parameter.tolerance,
        debounce: parameter.debounce,
        merge: parameter.merge,
        pvRate: parameter.pvRate,
        usePost: parameter.usePost,
        ajaxAsync: parameter.ajaxAsync,
        immediately: parameter.immediately,
    };
    util.extend(thisConfig, arg);

    var tolerance = thisConfig.tolerance;
    var debounce = thisConfig.debounce;


    var ads = util.getAds(arg);

    var impression = new Impression({
        tolerance: tolerance,
        debounce: debounce,
        // container: window
    });

    for (var i = 0, j = ads.length; i < j; i++) {
        var thisAd = ads[i];
        thisAd.setAttribute('data-midas-tag', 'true');
    }
    impression.on('begin', '[data-midas-tag="true"]', function (element) {
        addNewTask(element, thisConfig);
    });
};

MIDAS.initImpression = initImpression;


/**
 * Created by fanjingjian on 17/3/29.
 */

var clickAction = function (e, thisConfig) {
    var url = thisConfig.url;
    var usePost = thisConfig.usePost;
    var ajaxAsync = thisConfig.ajaxAsync;
    var callback = thisConfig.callback;
    var sendClickInReach = thisConfig.sendClickInReach;
    var stopClickPropagation = thisConfig.stopClickPropagation;
    var clickTimeout = thisConfig.clickTimeout;

    var ele = this;
    var selfMidasData = ele.getAttribute('data-midas');
    var linkUrl = ele.getAttribute('data-linkurl'); // data-inner-jump 模式下 页面的跳转地址
    var clickUrl = ele.getAttribute('data-clickurl'); // 第三方点击点


    var cur = e.target;
    // 追加信息 用于标识 点击的是广告的哪部分
    var curMidasExtendData = cur.getAttribute('data-midas-extends');

    // 拼装点击点的feedback
    var resultMidasData = selfMidasData;
    if (curMidasExtendData) {
        resultMidasData = decodeURIComponent(selfMidasData) + '&' + curMidasExtendData;
    }
    else {
        var midasExtendData = util.getParentsAttr(cur, 'data-midas-extends');
        if (midasExtendData) {
            resultMidasData = decodeURIComponent(selfMidasData) + '&' + midasExtendData;
        }
    }

    if (stopClickPropagation) {
        util.stopBubble(e);
    }

    var done = false;

    // 发送点击点
    // 包含 ？认为是完整的地址加参数 若未指定明确的 url ，按照feedback中的地址直接发送
    if (resultMidasData.indexOf('?') > -1 && typeof url === 'undefined') {
        url = resultMidasData.split('?')[0];
        resultMidasData = resultMidasData.split('?')[1];
    }

    // 本页跳转，打点数据在页面跳转前发送，页面跳转事件由打点组件执行
    // 新开页 跳转由业务方自己注册
    if (ele.getAttribute('data-inner-jump') === 'true') {

        // linkurl 中无 _fb_
        var linkUrlParams = linkUrl.split('?')[1] || '';
        var fb = {};
        if (linkUrlParams.length > 0) {
            fb = util.urlParams(linkUrlParams);
        }

        if (!fb['_fb_'] && !fb['feedback'] && !fb['feedBack']) {
            linkUrl += (linkUrl.indexOf('?') === -1 ? '?' : '&') + '_fb_=' + encodeURIComponent(resultMidasData);
        }

        // 设置了 sendClickInReach 属性 本页的点击点将随着
        if (sendClickInReach) {
            location.href = linkUrl;
            return null;
        }

        // 注册自定义事件 点击之后 等待所有未发送完毕的点发送完毕 再跳转
        util.eventBus.on('SEND_BEFORE_LEAVE', function (count) {
            if (count <= 0 && typeof linkUrl === 'string' && !done) {
                done = true;
                location.href = linkUrl;
            }
        });
        // 超时则立即跳转
        setTimeout(function () {
            if (!done) {
                location.href = linkUrl;
            }
        }, clickTimeout);
    }

    addTask({
        url: url,
        feedback: resultMidasData,
        act: 2,
        immediately: true,
        usePost: usePost,
        ajaxAsync: ajaxAsync,
        callback: callback,
    });
    // 第三方点击点
    if (clickUrl) {
        send(clickUrl);
    }

};

var initClick = function (arg) {

    arg = arg || {};
    var thisConfig = {
        usePost: parameter.usePost,
        ajaxAsync: parameter.ajaxAsync,
        sendClickInReach: parameter.sendClickInReach,
        stopClickPropagation: parameter.stopClickPropagation,
        clickTimeout: parameter.clickTimeout,
    };
    util.extend(thisConfig, arg);

    var ads = util.getAds(arg);
    for (var i = 0, j = ads.length; i < j; i++) {

        var ad = ads[i];
        var data = ad.getAttribute('data-midas');
        var isBinded = ad.getAttribute('data-click-inited');

        if (!isBinded) {
            util.addEventListener('click', function (e) {
                clickAction.call(this, e, thisConfig);
            }, false, ad);
            ad.setAttribute('data-click-inited', 'true');
        }
    }
};

MIDAS.initClick = initClick;

/**
 * Created by fanjingjian on 17/3/29.
 */

var init = function (arg) {
    // 传入非对象的参数
    if (typeof arg !== 'object' && typeof arg !== 'undefined') {
        throw new Error('config方法参数错误');
    }
    arg = arg || {};
    var thisConfig = {
        autoSendView: parameter.autoSendView,
        autoSendClick: parameter.autoSendClick,
        autoSendReach: parameter.autoSendReach,
    };
    util.extend(thisConfig, arg);

    var autoSendView = thisConfig.autoSendView;
    var autoSendClick = thisConfig.autoSendClick;
    var autoSendReach = thisConfig.autoSendReach;

    config(arg);

    if (autoSendView) {
        initView(arg);
    }

    initClick(arg);

    initImpression(arg);

    if (autoSendReach || autoSendClick) {
        autoSend(arg);
    }

};

MIDAS.init = init;

/**
 * Created by fanjingjian on 17/3/29.
 */

var autoSend = function (arg) {
    arg = arg || {};
    var thisConfig = {
        autoSendReach: parameter.autoSendReach,
        autoSendClick: parameter.autoSendClick,
        usePost: parameter.usePost,
        ajaxAsync: parameter.ajaxAsync,
    };
    util.extend(thisConfig, arg);

    var autoSendReach = thisConfig.autoSendReach;
    var autoSendClick = thisConfig.autoSendClick;
    var url = thisConfig.url;
    var callback = thisConfig.callback;
    var usePost = thisConfig.usePost;
    var ajaxAsync = thisConfig.ajaxAsync;

    var urlParams = util.urlParams();
    var fb = urlParams['_fb_'] || urlParams['feedback'] || urlParams['feedBack'];

    if (typeof fb !== 'string' || fb.length <= 0) {
        return null;
    }

    if (autoSendReach) {
        addTask({
            feedback: fb,
            act: 4,
            url: url,
            callback: callback,
            merge: false,
            usePost: usePost,
            ajaxAsync: ajaxAsync,
        });
    }
    if (autoSendClick) {
        addTask({
            feedback: fb,
            act: 2,
            url: url,
            callback: callback,
            usePost: usePost,
            ajaxAsync: ajaxAsync,
        });
    }
};

MIDAS.autoSend = autoSend;

/**
 * Created by fanjingjian on 17/3/28.
 */

var _shift = Array.prototype.shift;
var _slice = Array.prototype.slice;

/**
 * 向入口方法提供 用户注册事件名 和 功能函数名 之间的映射关系
 * @type {{config: *, listen: *, addTask: *, initView: *, initImpression: *, initClick: *}}
 * @private
 */
var _midas = {
    // 自动创建
    init: MIDAS.init,

    // 配置全局参数
    config: MIDAS.config,

    // 跨过发射器层 直接调用基础发送方法
    send: MIDAS.send,

    // 向队列中添加打点请求任务
    addTask: MIDAS.addTask,

    // 加载点 / 渲染点 -> act = 1
    initView: MIDAS.initView,

    // 曝光点 -> act = 3
    initImpression: MIDAS.initImpression,

    // 点击点 -> act = 2
    initClick: MIDAS.initClick,

    // 自动发送 cookie 中的数据
    autoSend: MIDAS.autoSend
};

/**
 * 调用用户注册事件
 * 若注册的是为止方法 直接执行回调
 */
var run = function () {
    var method = _shift.call(arguments);
    var arg = _slice.call(arguments);
    // 若传入的第二个参数为字符串
    try {
        _midas[method].apply(MIDAS, arg);
    }
    catch (e) {
        if(typeof _midas[method] !== 'function'){
            console.error('midas 方法参数不正确');
        }
        else{
            console.error(e);
        }
    }
};

var tastList = [];

/**
 * dom加载完毕的回调事件
 * 对任务列表中的每一项执行run方法
 */
var loadCallback = function () {
    for (var i = 0, l = tastList.length; i < l; i++) {
        run.apply(MIDAS, tastList[i]);
    }
};

// TODO: 台式机测试
MIDAS.util.DOMReady(loadCallback);

/**
 * 处理用户注册事件
 */
var midas = function thisPageMidas() {
    // 若调用midas时 document已经ready
    if (/complete|loaded|interactive/.test(document.readyState)) {
        run.apply(MIDAS, arguments);
    }
    else {
        tastList.push(arguments);
    }
};

if (noMD) {win.midas = midas;}
else {return midas;}});



//////////////////
// WEBPACK FOOTER
// ./~/@dp/midas/dist/midas.js
// module id = 24
// module chunks = 4